/* ==========================================================================
   Star rating -> review section

   Two jobs:
   1. Correct the numbers. The rating block renders from the review metafield,
      but reviews can also be added as blocks inside the review section, and
      Liquid cannot read another section's blocks. The review section publishes
      its own totals, so we take them when they are present.
   2. Scroll to the reviews on click, allowing for a sticky header.
   ========================================================================== */
(function () {
  if (window.__kbRatingScroll) return;
  window.__kbRatingScroll = true;

  function reviewRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-kb-reviews]'));
  }

  function sync() {
    var btn = document.querySelector('[data-kb-rate]');
    if (!btn) return;

    var roots = reviewRoots();
    if (!roots.length) return;

    /* Several instances can split one list, so add the totals up and take the
       weighted average rather than trusting whichever renders first. */
    var total = 0, weighted = 0;
    roots.forEach(function (r) {
      var n = parseInt(r.getAttribute('data-kb-reviews-total'), 10) || 0;
      var a = parseFloat(r.getAttribute('data-kb-reviews-avg')) || 0;
      total += n;
      weighted += a * n;
    });
    if (!total) return;

    var avg = Math.round((weighted / total) * 10) / 10;
    var tEl = btn.querySelector('[data-kb-rate-total]');
    var aEl = btn.querySelector('[data-kb-rate-avg]');
    if (tEl) tEl.textContent = total;
    if (aEl) aEl.textContent = avg;

    var filled = Math.round(avg);
    btn.querySelectorAll('.kb-rate__stars svg').forEach(function (svg, i) {
      svg.classList.toggle('on', i < filled);
      svg.classList.toggle('off', i >= filled);
    });
  }

  function headerOffset() {
    var h = document.querySelector('.section-header, .shopify-section-header-sticky, sticky-header');
    return h && getComputedStyle(h).position === 'sticky' ? h.getBoundingClientRect().height + 12 : 16;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kb-rate]');
    if (!btn) return;

    /* The first review section carries the summary; fall back to any of them. */
    var roots = reviewRoots();
    var target = roots.filter(function (r) {
      return r.getAttribute('data-kb-reviews-summary') === 'true';
    })[0] || roots[0];
    if (!target) return;

    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  /* Theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', sync);
})();
